var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.651.795l2.537 1.723C5.704 4.544 4.938 6.73 4.89 9.074v3.254H.488V9.552c0-1.627.383-3.238 1.149-4.833C2.418 3.124 3.423 1.816 4.65.795zm7.537 0l2.536 1.723c-1.483 2.026-2.249 4.211-2.297 6.556v3.254H8.025V9.552c0-1.627.383-3.238 1.148-4.833.782-1.595 1.787-2.903 3.015-3.924z",
    fill: "#3A50F3"
  })));
}

export default __webpack_public_path__ + "./fonts/quote.fa30a4f970f0f22c5c91bef928e14cf2.svg";
export { SvgQuote as ReactComponent };